import { StatusTag } from "../../ui/StatusTag";
import type { Priority, Severity } from "../../../types/interfaces";
import { PRIORITY_LABEL, PRIORITY_TONE, SEVERITY_LABEL, SEVERITY_TONE } from "./format";

export const SeverityTag = ({ severity }: { severity: Severity }) => (
  <StatusTag label={SEVERITY_LABEL[severity]} tone={SEVERITY_TONE[severity]} dot />
);
export const PriorityTag = ({ priority }: { priority: Priority }) => (
  <StatusTag label={PRIORITY_LABEL[priority]} tone={PRIORITY_TONE[priority]} />
);
